"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoricalColorsArray = exports.CategoricalColors = exports.SequentialChartColor = void 0;
var variables_1 = require("../../../style/variables");
exports.SequentialChartColor = {
    Blue: {
        SEQUENCE_0: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        SEQUENCE_1: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
        SEQUENCE_2: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
        SEQUENCE_3: "var(" + variables_1.ThemeColor.Primary.DARK_2 + ")",
        SEQUENCE_4: "var(" + variables_1.ThemeColor.Primary.DARK_3 + ")",
        SEQUENCE_5: "var(" + variables_1.ThemeColor.Primary.DARK_4 + ")",
    },
};
exports.CategoricalColors = {
    CATEGORICAL_1: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
    CATEGORICAL_2: "var(" + variables_1.RootColor.Orange.DARK_1 + ")",
    CATEGORICAL_3: "var(" + variables_1.RootColor.Teal.DARK_2 + ")",
    CATEGORICAL_4: "var(" + variables_1.RootColor.Pink.DARK_1 + ")",
    CATEGORICAL_5: "var(" + variables_1.RootColor.Violet.DEFAULT + ")",
    CATEGORICAL_6: "var(" + variables_1.RootColor.Yellow.DARK_1 + ")",
    CATEGORICAL_7: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
    CATEGORICAL_8: "var(" + variables_1.RootColor.Orange.DARK_2 + ")",
    CATEGORICAL_9: "var(" + variables_1.RootColor.Teal.DARK_3 + ")",
    CATEGORICAL_10: "var(" + variables_1.RootColor.Pink.DARK_4 + ")",
    CATEGORICAL_11: "var(" + variables_1.RootColor.Violet.DARK_1 + ")",
    CATEGORICAL_12: "var(" + variables_1.RootColor.Yellow.DARK_2 + ")",
    CATEGORICAL_13: "var(" + variables_1.ThemeColor.Gray.DEFAULT + ")",
};
exports.categoricalColorsArray = Object.values(exports.CategoricalColors);
